import React from "react"
import { injectIntl } from "react-intl"
import { useSelector } from "react-redux"
import { StatusBadge } from "../../../../common/badge"
import { BasicRow } from "../../../../common/listing/ListingTypes"
import StandardList from "../../../../common/listing/list.component"
import IntlProps from "../../../../state/helpers/IntlProps"
import { InventoryStockDocumentDefinitionSelector } from "../../../../state/inventory"
import {
    DOCUMENT_TYPES_STATUS_TAB_MESSAGES
} from "../../../../utils/inventory"
import { STOCK_DOCUMENT_DEFINITION_STATUS_HEADERS } from "../../../../utils/inventory/utils"

export const Status = injectIntl((props: IntlProps) => {
    const statuses = useSelector(InventoryStockDocumentDefinitionSelector.getStatuses)

    const rows: Array<BasicRow> = statuses.map(status => {
        return {
            rowId: status.id,
            data: [
                status.name,
                <StatusBadge key={status.id} colorCode={status.colorCode} text={status.name}/>,
            ]
        }
    })

    return (
        <div className="col-12 mt-2">

            <small className="form-text text-muted">
                {props.intl.formatMessage(DOCUMENT_TYPES_STATUS_TAB_MESSAGES["description"])}
            </small>

            <StandardList
                className="pl-0"
                headers={STOCK_DOCUMENT_DEFINITION_STATUS_HEADERS}
                rows={rows}
            />
        </div>
    )
})


// WEBPACK FOOTER //
// ./src/inventory/sections/documentTypes/tabs/Status.tsx